import React from 'react';
import { Link, useParams } from 'react-router-dom';
import solutions from '../data/solutions';
import './SolutionDetail.css';
import useReveal from '../hooks/useReveal';
import TokenRevealText from '../components/TokenRevealText';

const SolutionDetail = () => {
  useReveal();
  const { id } = useParams();
  const solution = solutions.find((item) => item.id === id);

  if (!solution) {
    return (
      <main className="solution-detail page-enter">
        <section className="page-hero">
          <div className="container reveal">
            <p className="section-eyebrow-light">
              <TokenRevealText text="Engineering Solutions – From Concept to Product" speed="medium" />
            </p>
            <h1><TokenRevealText text="Solution Not Found" speed="medium" /></h1>
            <p><TokenRevealText text="Please return to the solutions page." speed="medium" /></p>
            <Link to="/solutions" className="btn-primary">
              <TokenRevealText text="Back to Solutions" speed="medium" />
            </Link>
          </div>
        </section>
      </main>
    );
  }

  const imageCandidates = solution.imageCandidates || [];
  const fallbackImage = '/images/C2P.jpg';
  const imageSrc = imageCandidates[0] || fallbackImage;
  const isIntegrated = solution.id === 'integrated';

  return (
    <main className="solution-detail page-enter">
      <section className="page-hero">
        <div className="container reveal">
          <p className="section-eyebrow-light">
            <TokenRevealText text="Engineering Solutions – From Concept to Product" speed="medium" />
          </p>
          <h1><TokenRevealText text={solution.title} speed="medium" /></h1>
        </div>
      </section>

      <section className="section solution-overview">
        <div className="container grid-2">
          <div className="media-card reveal reveal-left" style={{ minHeight: '340px' }}>
            {isIntegrated && imageCandidates.length > 1 ? (
              <div className="solution-media-grid">
                {imageCandidates.map((src, index) => (
                  <img
                    key={src}
                    src={src}
                    alt={`${solution.title} ${index + 1}`}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = fallbackImage;
                    }}
                  />
                ))}
              </div>
            ) : (
              <img
                src={imageSrc}
                alt={solution.title}
                onError={(e) => {
                  const img = e.currentTarget;
                  const currentIndex = Number(img.dataset.candidateIndex || '0');

                  if (imageCandidates.length > 0 && currentIndex < imageCandidates.length - 1) {
                    img.dataset.candidateIndex = String(currentIndex + 1);
                    img.src = imageCandidates[currentIndex + 1];
                    return;
                  }

                  img.onerror = null;
                  img.src = fallbackImage;
                }}
                data-candidate-index="0"
              />
            )}
          </div>
          <div className="reveal reveal-right">
            <p className="section-eyebrow"><TokenRevealText text="Overview" speed="medium" /></p>
            <h2 className="section-title"><TokenRevealText text={solution.title} speed="medium" /></h2>
            <div className="divider" />
            <p className="body-text"><TokenRevealText text={solution.desc} speed="medium" /></p>
          </div>
        </div>
      </section>

      <section className="section section-alt solution-details">
        <div className="container">
          <div className="solution-grid">
            <div className="solution-block reveal reveal-scale reveal-d1">
              <h3><TokenRevealText text="Use Cases" speed="medium" /></h3>
              <ul>
                {solution.useCases.map((item) => (
                  <li key={item}><TokenRevealText text={item} speed="medium" /></li>
                ))}
              </ul>
            </div>
            <div className="solution-block reveal reveal-scale reveal-d2">
              <h3><TokenRevealText text="Industries" speed="medium" /></h3>
              <ul>
                {solution.industries.map((item) => (
                  <li key={item}><TokenRevealText text={item} speed="medium" /></li>
                ))}
              </ul>
            </div>
            <div className="solution-block reveal reveal-scale reveal-d3">
              <h3><TokenRevealText text="Applications" speed="medium" /></h3>
              <ul>
                {solution.applications.map((item) => (
                  <li key={item}><TokenRevealText text={item} speed="medium" /></li>
                ))}
              </ul>
            </div>
          </div>
          <div className="solution-back reveal">
            <Link to="/solutions" className="btn-primary">
              <TokenRevealText text="Back to Solutions" speed="medium" />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SolutionDetail;
